import { formatRouteForAAB } from "./format-route-for-aab.js";
const urlFromSessionStorageItem = ({
  sessionStorageItem,
  appointmentMenuItems,
  appointmentRoute
}) => {
  try {
    const state = JSON.parse(sessionStorageItem);
    if (!Object.keys(state?.queryParams).length) {
      return appointmentMenuItems;
    }
    return formatRouteForAAB({
      appointmentMenuItems,
      appointmentRoute,
      route: state?.currentRoute,
      searchParams: new URLSearchParams(state?.queryParams).toString()
    });
  } catch {
    return appointmentMenuItems;
  }
};
export {
  urlFromSessionStorageItem
};
//# sourceMappingURL=url-from-session-storage-item.js.map
